.dashletAlignmentColumn {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1 1 0px;
}

.dashletAlignmentRow {
    display: flex;
    flex-direction: row;
    gap: 20px;
    flex: 1 1 0px;
}

.dashlet {
    border-radius: 1rem;
    padding: 20px;
    height: 100%;
    width: 100%;
    background-color: #05263743;
    flex: 1 1 0px;
}

.title {
    display: flex;
}
